import React from "react";
import { Table } from "antd";
import classNames from "classnames";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { TableLocale } from "@components/noDataFound";

const TableWithStaticPagination = ({ pagination = false, loading, className, columns, data, height }: any) => {
  const tableClassNames = classNames("ui-new-generic-table", className);
  return <Table {...(height? {scroll:  {y: height} } : {})} loading={loading ? { spinning: loading, indicator: <HealthemSpinner size={45}/> } : false} className={tableClassNames} columns={columns} dataSource={data} bordered pagination={pagination} locale={TableLocale}/>;
};

export default TableWithStaticPagination;
